import { fetchCatalogsIfNeeded, getCatalog } from './catalog';
import { fetchBidIncrementsIfNeeded } from './bidIncrements';
import { fetchCatalogDetailsIfNeeded } from './catalogDetail';
import { fetchCatalogItemModels } from './catalogItems';
import { fetchConsoleBrandingIfNeeded } from './consoleBranding';
import { fetchCoverLotsIfNeeded } from './coverLots';
import { fetchSellersDetailsIfNeeded } from './sellerDetail';
import { fetchStreamIdIfNeeded } from './video';
import { getNotFoundUrl } from '@/utils/urls';
import { push } from 'connected-react-router';
import TEST_HOUSES from '@/utils/testHouses';

/* ACTION CREATORS */
export const fetchDataForBiddingConsolePage = (catalogId: number) => async (dispatch: Function, getState: Function) => {
    // If we dont have the catalogId here then we're going to abort
    if (!catalogId) {
        return Promise.all([dispatch(push(getNotFoundUrl()))]);
    }

    await dispatch(fetchCatalogsIfNeeded([catalogId]));

    const state = getState();
    const { sellerId } = getCatalog(state, catalogId);

    if (!sellerId) {
        return Promise.all([dispatch(push(getNotFoundUrl()))]);
    }

    const query: any = { pageSize: 'all', sort: 'lotNumber' };
    if (TEST_HOUSES.includes(sellerId)) {
        query.preview = true;
    }

    await Promise.all([
        dispatch(fetchBidIncrementsIfNeeded(catalogId)),
        dispatch(fetchCatalogDetailsIfNeeded([catalogId])),
        dispatch(fetchCoverLotsIfNeeded([catalogId])),
        dispatch(fetchCatalogItemModels({ catalogId, query })),
        dispatch(fetchStreamIdIfNeeded(catalogId)),
        dispatch(fetchSellersDetailsIfNeeded([sellerId])),
        dispatch(fetchConsoleBrandingIfNeeded(catalogId, sellerId)),
    ]);

    const promises = [];

    return Promise.all(promises);
};
